const initialState = {
    leads: [],
    lead: null,
    isLoading: false,
    isError: false,
    errorMessage: '',
    leadUpdated: null,
    leadCreated: null,
}

export default function leadReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_ALL_LEADS':
            return { ...state, leads: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'GET_LEAD':
            return { ...state, lead: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'UPDATE_LEAD':
            return { ...state, leadUpdated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'CREATE_LEAD':
            return { ...state, leadCreated: action.payload, errorMessage: '', isError: false, isLoading: false };
        case 'LEAD_ACTION_STARTS':
            return { 
                ...state, 
                isLoading: true,
                leadCreated: null,
                leadUpdated: null,
                isError: false,
                errorMessage: ''
            };
        case 'LEAD_ACTION_ERRORS':
            return { ...state, isError: true, errorMessage: action.payload, isLoading: false };
        case 'RESET_LEAD_ERRORS':
            return { 
                ...state, 
                isError: false, 
                errorMessage: '',
            };
        default:
            return state;
    }
}